<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="420">
    <v-card>
        <v-toolbar dense color="secondary" dark>
           <v-icon left color="primary">mdi-cash-register</v-icon> PAYMENT
             <v-spacer/>
              <v-icon @click="emitToParent('close')">mdi-close</v-icon>
        </v-toolbar>
            
             <v-form
                ref="form"
                class="ma-2"
                v-model="valid"
                lazy-validation
              >
                <v-row dense>
                  <v-col cols="12">
                        <v-expansion-panels>
                            <v-expansion-panel>
                              <v-expansion-panel-header @click="payment_method='Cash'"><span><v-icon large left color="primary">mdi-cash</v-icon> CASH</span></v-expansion-panel-header>
                              <v-expansion-panel-content>
                                    <p class="text-center">
                                     <v-btn  color="secondary"  block @click="payment_method='Cash', validate()"><v-icon left>mdi-check</v-icon> CASH</v-btn>
                                   </p>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                              <v-expansion-panel-header @click="payment_method='Cheque'"><span><v-icon left color="success">mdi-bank</v-icon> CHEQUE</span> </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <v-text-field 
                                      v-model="check_details.bank"
                                      filled
                                      dense
                                      outlined
                                      label="Enter bank name"
                                    />
                                    <v-text-field 
                                      v-model="check_details.cheque_no"
                                      filled
                                      dense
                                      outlined
                                      label="Enter cheque #."
                                    />
                                     <v-text-field 
                                      v-model="check_details.cheque_amount"
                                      filled
                                      dense
                                      outlined
                                      label="Enter Amount"
                                    />
                                    <p class="text-center">
                                       <v-btn  color="secondary"  block @click="validate()"><v-icon left>mdi-check</v-icon> Complete Payment</v-btn>
                                    </p>
                                </v-expansion-panel-content>
                            </v-expansion-panel>

                        </v-expansion-panels>
                  </v-col>
                </v-row>
             
             </v-form>
      
    </v-card>
    <va-confirm :show="confirm" cancelbtn="No" okbtn="Complete" text="Complete Payment?" @DialogEvent="cEvent"/>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
     total:{
      type:Number,
       default: 0
    },
    summary:{
      type:Array,
       default: ()=>[]
    }
  },
  data: () => ({
      valid: true,
      confirm: false,
      check_details:{},
      payment_method:'',
      credit_amount:"",
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
   
   
  },
  watch: {
    show(v) {
      if(v) {
          this.payment_method = "Cash"
      }
    }
  },
  methods: {
      validate () {
        if (this.$refs.form.validate()) {
           this.confirm = true
        }
      },
    emitToParent (action) {
      this.$emit('DialogEvent', action)
    },
    cEvent(data) {
      this.confirm = false
      if(data == 'ok') {
        this.$emit('DialogEvent', {method: this.payment_method, check_details: this.check_details})
      } 
    },
   
  }
}
</script>
